import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    liquidacionSueldosId: 0,
    periodo: moment(new Date()).format('YYYY-MM-DD'),
    liquidacionesPersonal: [],

    cajaRegistroId: 0,
    cajaRegistro: null,
    cajaRegistroNombre: null,
    pesos: 0,
    importeChequesPropios: 0,
    chequesPropios: [],
    importeTransferencias: 0,
    transferencias: [],

    total: {
        honorarios: 0,
        adicionales: 0,
        otrosConceptos: 0,
        liquidacionesFinales: 0,
        adelantos: 0,
        total: 0,
        saldo: 0,
    },

    totalLiquidacion: 0,
};

const mutations = {
    updateField,

    'INICIALIZAR' (state, liquidacionSueldosId) {
        state.liquidacionSueldosId = liquidacionSueldosId;
        state.periodo = moment.utc(new Date()).format('YYYY-MM-DD')
        state.liquidacionesPersonal = [];

        state.cajaRegistroId = 0;
        state.cajaRegistro = null;
        state.cajaRegistroNombre = null;

        state.pesos = 0;
        state.importeChequesPropios = 0;
        state.importeTransferencias = 0;
        state.chequesPropios = [];
        state.transferencias = [];
            
        state.total.honorarios = 0;
        state.total.adicionales = 0;
        state.total.otrosConceptos = 0;
        state.total.liquidacionesFinales = 0;
        state.total.adelantos = 0;
        state.total.total = 0;
        state.total.saldo = 0;

        state.totalLiquidacion = 0;

    },
    'SET_LIQUIDACION_SUELDOS' (state, liquidacionSueldos) {
        state.periodo = moment(liquidacionSueldos.periodo).format('YYYY-MM-DD')

        state.liquidacionesPersonal = liquidacionSueldos.liquidacionesPersonal
            .map(personal => ({
                ...personal,
                importe: personal.facturaHonorarios? 0 : personal.saldo,
                _rowVariant: ''
            }))
            .sort(function(a, b){
                let x = a.personal.toLowerCase().trim();
                let y = b.personal.toLowerCase().trim();
                if (x < y) { 
                    return -1; 
                }
                if (x > y) {
                    return 1;
                }
                return 0;
            });
    
        state.total.honorarios = state.liquidacionesPersonal
            .reduce((total, liquidacionPersonal) => {
                return total + parseFloat(liquidacionPersonal.honorarios);
            }, 0);
        state.total.adicionales = state.liquidacionesPersonal
            .reduce((total, liquidacionPersonal) => {
                return total + parseFloat(liquidacionPersonal.adicional);
            }, 0);
        state.total.otrosConceptos = state.liquidacionesPersonal
            .reduce((total, liquidacionPersonal) => {
                return total + parseFloat(liquidacionPersonal.otrosConceptos);
            }, 0);
        state.total.liquidacionesFinales = state.liquidacionesPersonal
            .reduce((total, liquidacionPersonal) => {
                return total + parseFloat(liquidacionPersonal.liquidacionFinal);
            }, 0);
        state.total.adelantos = state.liquidacionesPersonal
            .reduce((total, liquidacionPersonal) => {
                return total + parseFloat(liquidacionPersonal.adelantos);
            }, 0);

        state.total.total = state.total.honorarios + state.total.adicionales 
            + state.total.otrosConceptos + state.total.liquidacionesFinales - state.total.adelantos;

        state.total.saldo = state.liquidacionesPersonal
            .reduce((total, liquidacionPersonal) => {
                return total + parseFloat(liquidacionPersonal.saldo);
            }, 0);
        
        calcularTotales(state);
    },
    'CALCULAR_TOTALES'(state) {
        calcularTotales(state);
    },

    'SET_CAJA_REGISTRO' (state, cajaRegistro) {
        state.cajaRegistro = cajaRegistro;
        if (cajaRegistro) {
            state.cajaRegistroId = cajaRegistro.id? cajaRegistro.id : 0;
            state.cajaRegistroNombre = cajaRegistro.nombre? cajaRegistro.nombre.trim() : null;
        } else {
            state.cajaRegistroId = 0;
            state.cajaRegistroNombre = null;
        }
    },
    'SET_CHEQUE_PROPIO' (state, chequePropio) {
        state.chequesPropios.push(chequePropio);

        state.importeChequesPropios = 0;
        if (state.chequesPropios.lenght != 0) {
            state.importeChequesPropios = state.chequesPropios
                .reduce((a, b) => a + b.importe, 0);
        }
    },
    'DELETE_CHEQUE_PROPIO' (state, chequePropio) {
        let itemKey = state.chequesPropios
            .findIndex(cheque => cheque == chequePropio);

        if (itemKey != -1) {
            state.chequesPropios.splice(itemKey, 1);
        }

        state.importeChequesPropios = 0;
        if (state.chequesPropios.lenght != 0) {
            state.importeChequesPropios = state.chequesPropios
                .reduce((a, b) => a + b.importe, 0);
        }
    },

    'SET_TRANSFERENCIA' (state, transferencia) {
        state.transferencias.push(transferencia);

        state.importeTransferencias = 0;
        if (state.transferencias.lenght != 0) {
            state.importeTransferencias = state.transferencias
                .reduce((a, b) => a + b.importe, 0);
        }
    },
    'DELETE_TRANSFERENCIA' (state, transferencia) {
        let itemKey = state.transferencias
            .findIndex(t => t == transferencia);

        if (itemKey != -1) {
            state.transferencias.splice(itemKey, 1);
        }

        state.importeTransferencias = 0;
        if (state.transferencias.lenght != 0) {
            state.importeTransferencias = state.transferencias
                .reduce((a, b) => a + b.importe, 0);
        }
    },
};

function calcularTotales(state) {
    validarImportes(state);

    state.totalLiquidacion = state.liquidacionesPersonal
        .reduce((total, liquidacionPersonal) => {
            return total + parseFloat(liquidacionPersonal.importe);
        }, 0);
}
function existsImportePagoInvalido(state) {
    let exists = false;
    
    state.liquidacionesPersonal.forEach(liquidacionPersonal => {
        if (parseFloat(liquidacionPersonal.importe) > parseFloat(liquidacionPersonal.saldo)) {
            exists = true;
            liquidacionPersonal._rowVariant = 'danger';
        } else {
            liquidacionPersonal._rowVariant = '';
        }
    });

    return exists;
}
function validarImportes(state) {
    state.liquidacionesPersonal.forEach(liquidacionPersonal => {
        if (parseFloat(liquidacionPersonal.importe) > parseFloat(liquidacionPersonal.saldo)) {
            liquidacionPersonal._rowVariant = 'danger';
        } else {
            liquidacionPersonal._rowVariant = '';
        }
    });
}

function getTotalDocumentos (state) {
    return parseFloat(state.pesos) 
        + parseFloat(state.importeChequesPropios)
        + parseFloat(state.importeTransferencias);
}

function getSaldo (state) {
    return parseFloat(state.totalLiquidacion) - getTotalDocumentos(state);
}


const getters = {
    getField,
};

const actions = {
    inicializar ( { commit }, liquidacionSueldosId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR', liquidacionSueldosId);

            /* Recuperamos los datos del periodo a liquidar */
            apiAxios.get(`liquidaciones-sueldos/${liquidacionSueldosId}/pago`) 
                .then(res => {
                    commit('SET_LIQUIDACION_SUELDOS', res.data);

                    /* Recuperamos la caja central */
                    return apiAxios.get('cajas/central')
                })
                .then((res) => {
                    commit("SET_CAJA_REGISTRO", res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
    save ( { state } ) {
        return new Promise((resolve, reject) => {
            let save = true;
            let errorMessage = '';
            
            let totalDocumentos = getTotalDocumentos(state);
            let saldo = getSaldo(state);

            if (saldo > 0.1) {
                save = false;
                errorMessage = "El pago de liquidaciones de sueldos no permite pagos parciales. Verifique los valores de los documentos ingresados."
            }

            // if (existsImportePagoInvalido(state)) {
            //     save = false;
            //     errorMessage = "El importe a pagar no puede ser mayor al saldo para cada recurso incluido en el pago actual."
            // }

            if (save) {
                let liquidacionSueldosPersonal = state.liquidacionesPersonal
                    .filter(liquidacionPersonal => parseFloat(liquidacionPersonal.importe) != 0)
                    .map(liquidacionPersonal => ({
                        id: liquidacionPersonal.id,
                        personalId: liquidacionPersonal.personalId,
                        importe: parseFloat(liquidacionPersonal.importe)
                    }));
                
                let liquidacionSueldosPago= {
                    liquidacionesPersonal: liquidacionSueldosPersonal,
                    cajaRegistroId: state.cajaRegistroId,
                    pesos: parseFloat(state.pesos),
                    transferencias: state.transferencias,
                    chequesPropios: state.chequesPropios,
                };

                apiAxios.post(`liquidaciones-sueldos/${state.liquidacionSueldosId}/pago`, liquidacionSueldosPago)
                    .then(() => resolve())
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                reject(errorMessage);
            }
        })
    },
    setCajaRegistro ( { commit }, cajaRegistro ) {
        commit('SET_CAJA_REGISTRO', cajaRegistro);
    },
    setTransferencia ( { commit }, transferencia ) {
        commit('SET_TRANSFERENCIA', transferencia);
    },
    deleteTransferencia ( { commit }, transferencia ) {
        commit('DELETE_TRANSFERENCIA', transferencia);
    },
    setChequePropio ( { commit }, chequePropio ) {
        commit('SET_CHEQUE_PROPIO', chequePropio);
    },
    deleteChequePropio ( { commit }, chequePropio ) {
        commit('DELETE_CHEQUE_PROPIO', chequePropio);
    },
    calcularTotales ( { commit } ) {
        commit('CALCULAR_TOTALES');
    },

    deletePagos ( {}, liquidacionSueldosId ) {
        return new Promise((resolve, reject) => {
            apiAxios.post(`liquidaciones-sueldos/${liquidacionSueldosId}/pago/delete`)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
    delete ( {}, params ) {
        return new Promise((resolve, reject) => {
            apiAxios.post(`liquidaciones-sueldos/${params.liquidacionSueldosId}/pago/${params.liquidacionSueldosPagoId}/delete`)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}